import { render, staticRenderFns } from "./UOttawaKineticReactionOrderAiResearch.vue?vue&type=template&id=616ed95e&"
import script from "./UOttawaKineticReactionOrderAiResearch.vue?vue&type=script&lang=js&"
export * from "./UOttawaKineticReactionOrderAiResearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VForm,VRadio,VRadioGroup,VSimpleTable})
